

import NumberCore from '@/modules/NumberCore/NumberCore';
import { Component, VModel, Vue, Prop } from 'vue-property-decorator';
import IBTextField from './TextField.vue';

@Component({
	components: {
		IBTextField
	}
})
export default class IBInputField extends Vue {

	$refs!: {
		textField: IBTextField
	}

	@VModel({ type: String })
	model!: string

	@Prop(String)
	readonly mask?: string

	@Prop(String)
	readonly errorMessage?: string

	@Prop(Number)
	readonly maxLength?: number

	@Prop(String)
	readonly type?: string

	@Prop(RegExp)
	readonly regExp?: RegExp

	get id(): string {
		return `id_${NumberCore.uniqueId}`;
	}

}

